// src/components/resources/ResourceButtons.tsx
import React from 'react';

const ResourceButtons: React.FC = () => {
  // URLs for resources
  const nasemsoUrl = "https://ems.utah.gov/wp-content/uploads/sites/34/2024/05/National-Model-EMS-Clinical-Guidelines_2022.pdf";
  const rubricUrl = "https://how2emt.com/wp-content/uploads/2025/03/Binder2.pdf";

  return (
    <div className="hidden flex space-x-2">
      <a
        href={nasemsoUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-3 py-1 rounded-md shadow-sm transition-colors"
        onClick={(e) => {
          e.preventDefault();
          window.open(nasemsoUrl, '_blank', 'noopener,noreferrer');
        }}
      >
        NASEMSO
      </a>
      <a
        href={rubricUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-600 hover:bg-green-700 text-white text-sm px-3 py-1 rounded-md shadow-sm transition-colors"
        onClick={(e) => {
          e.preventDefault();
          window.open(rubricUrl, '_blank', 'noopener,noreferrer');
        }}
      >
        Rubric
      </a>
    </div>
  );
};

export default ResourceButtons;